import {
  Breadcrumbs,
  Container,
  Grid,
  Pagination,
  Section,
  Stack,
} from "@storoey/sui";
import { createFileRoute, useRouter } from "@tanstack/solid-router";
import { For } from "solid-js";
import { z } from "zod";
import { backendService } from "../../../backend/backend.service";
import { PhotoCard } from "../../../components/PhotoCard/PhotoCard";
import { usePageTitle } from "../../../hooks/usePageTitle";
import { toOffsetLimit } from "../../../utils/to-offset-limit";

export const Route = createFileRoute("/settings/storage/photos")({
  validateSearch: z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(8).default(8),
  }),
  loaderDeps: ({ search: { page, pageSize } }) => ({ page, pageSize }),
  loader: async ({ deps: { page, pageSize } }) => {
    const { offset, limit } = toOffsetLimit(page, pageSize);

    const { data, total } = await backendService.getPhotosPaged(offset, limit);

    return { page, pageSize, data, total };
  },
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("Bilder");
  const loaderData = Route.useLoaderData();
  const navigate = Route.useNavigate();
  const router = useRouter();

  const handleDeletePhoto = async (photoId: number) => {
    await backendService.deletePhoto(photoId);
    await router.invalidate();
  };

  return (
    <Section
      padding="lg"
      breadcrumbs={
        <Container>
          <Breadcrumbs>
            <Breadcrumbs.Item onClick={() => navigate({ to: "/" })}>
              Hjem
            </Breadcrumbs.Item>
            <Breadcrumbs.Item onClick={() => navigate({ to: "/settings" })}>
              Innstillinger
            </Breadcrumbs.Item>
            <Breadcrumbs.Item
              onClick={() => navigate({ to: "/settings/storage" })}
            >
              Lagring
            </Breadcrumbs.Item>
            <Breadcrumbs.Item current>Bilder</Breadcrumbs.Item>
          </Breadcrumbs>
        </Container>
      }
    >
      <Container>
        <Stack>
          <Grid columns={4}>
            <For each={loaderData().data}>
              {(photo) => (
                <PhotoCard photo={photo} onDelete={handleDeletePhoto} />
              )}
            </For>
          </Grid>
          <Stack align="center">
            <Pagination
              page={loaderData().page}
              totalPages={Math.ceil(loaderData().total / loaderData().pageSize)}
              onPageChange={(page) =>
                navigate({
                  search: (prev) => ({
                    ...prev,
                    page,
                  }),
                })
              }
            />
          </Stack>
        </Stack>
      </Container>
    </Section>
  );
}
